import React from "react";
import Content from "../../UI/Content";

const About = ({
  title,
  heading,
  content,
  content1,
  orderImg,
  orderContent,
  classes,
  image1,
}) => {
  return (
    <div
      className={`page-about-wrapper my-5 sm-top about-page-section ${classes}`}
    >
      <div className="container">
        <div className="row align-items-lg-center">
          {/* Left Column */}
          <div className={`col-md-6 col-lg-7 order-${orderContent}`}>
            <Content classes="about-content ml-0">
              <h6>{title}</h6>
              <h2 dangerouslySetInnerHTML={{ __html: heading }} />
              <p dangerouslySetInnerHTML={{ __html: content }} />
              <img
                src={image1}
                classes="about-thumb about-page-img"
                alt="about"
              />
            </Content>
          </div>

          {/* Right Column - also showing content */}
          <div className={`col-md-6 col-lg-5 order-0 order-md-${orderImg}`}>
            <Content classes="about-content ml-0">
              <p dangerouslySetInnerHTML={{ __html: content1 }} />
            </Content>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
